import {
  ApplicationRef,
  DestroyRef,
  Directive,
  ElementRef,
  EnvironmentInjector,
  HostListener,
  inject,
  input,
  TemplateRef
} from '@angular/core';
import { FloatingPopoverHelper } from './floating-popover.helper';

@Directive({
  selector: '[floatingPopoverTrigger]',
  standalone: true
})
export class FloatingPopoverTriggerDirective {
  private readonly destroyRef = inject(DestroyRef);
  private readonly elementRef = inject(ElementRef<HTMLElement>);
  private readonly popoverController = new FloatingPopoverHelper(
    inject(ApplicationRef),
    inject(EnvironmentInjector)
  );

  floatingPopoverTrigger = input<TemplateRef<unknown> | null>(null);
  floatingPopoverContext = input<Record<string, unknown> | null>(null);

  constructor() {
    this.destroyRef.onDestroy(() => this.popoverController.remove());
  }

  @HostListener('mouseenter')
  protected onMouseEnter(): void {
    this.showPopover();
  }

  @HostListener('mouseleave')
  protected onMouseLeave(): void {
    this.scheduleHide();
  }

  private showPopover(): void {
    this.popoverController.show(
      this.elementRef.nativeElement,
      this.floatingPopoverTrigger(),
      this.floatingPopoverContext() || {}
    );
  }

  private scheduleHide(): void {
    this.popoverController.scheduleHide();
  }
}
